// Length unit conversion. Dimensions are stored canonically in centimetres.
export const LENGTH_UNITS = ["mm", "cm", "m", "inch", "ft"];

const TO_CM = { mm: 0.1, cm: 1, m: 100, inch: 2.54, ft: 30.48 };

export function toCm(value, unit) {
  return (Number(value) || 0) * (TO_CM[unit] || 1);
}

export function fromCm(cm, unit) {
  return (Number(cm) || 0) / (TO_CM[unit] || 1);
}

export function convertLength(value, fromUnit, toUnit) {
  return fromCm(toCm(value, fromUnit), toUnit);
}

export function roundN(n, digits = 2) {
  const p = Math.pow(10, digits);
  return Math.round((Number(n) || 0) * p) / p;
}
